import axios from 'axios'

// axios.defaults.baseURL = "http://127.0.0.1:8000/";
axios.defaults.baseURL = "https://laravel-passport.issaissifou.fr/";
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
